export default {
  productGroups: [],
  productGroup: undefined,
};
